import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import UserService from '../services/UserService';
import { hasDeals } from '../services/categories';
import DealCard from './DealCard';
import './Home.css';

const PAGE_SIZE = 12;

// Shared layout for the Category, Store and Search pages.
//   title       - heading, e.g. "Clothes Deals"
//   crumb       - last part of the breadcrumb, e.g. "Clothes"
//   loadDeals   - function that returns the axios request for the deals
//   reloadKey   - when this changes (new category/store/search), deals load again
//   emptyText   - message when there are no deals
//   activeCategory - highlights this category in the sidebar
function DealListPage({ title, crumb, loadDeals, reloadKey, emptyText, activeCategory }) {
  const [deals, setDeals] = useState([]);
  const [count, setCount] = useState(PAGE_SIZE);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    UserService.getCategory().then((res) => setCategoryData(res.data)).catch((err) => console.error("Failed to load categories", err))
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    setError(false);
    setCount(PAGE_SIZE);
    loadDeals().then((res) => {
      setDeals(res.data);
    }).catch((err) => {
      console.error("Failed to load deals", err);
      setError(true);
    }).finally(() => setLoading(false));
  // loadDeals changes on every render; reloadKey says when to really reload
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadKey]);

  // old: const categoryLinks = categoryData.map((c) =>
  // new: only show categories that have deals
  const categoryLinks = categoryData.filter(hasDeals).map((c) =>
    <Link key={c.category_id ?? c.category} to={"/category/" + c.category}
      className={c.category === activeCategory ? "active" : undefined}>
      {c.category}
    </Link>
  );

  return (
    <div className="home-page">
      <div className="home-layout">
        <main>
          <nav className="list-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>›</span>
            <span>{crumb}</span>
          </nav>

          <nav className="home-cat-chips" aria-label="Categories">{categoryLinks}</nav>

          <h1 className="home-section-title">
            {title}
            {!loading && !error && deals.length > 0 && <small className="list-count">{deals.length} deals</small>}
          </h1>

          {error ? (
            <p className="home-message">Something went wrong loading these deals. Please refresh the page in a minute.</p>
          ) : loading ? (
            <div className="home-message">
              <Spinner animation="border" />
              <p>Loading deals...</p>
            </div>
          ) : deals.length === 0 ? (
            <div className="home-message">
              <p>{emptyText}</p>
              <p><Link to="/" className="list-back">← Back to all deals</Link></p>
            </div>
          ) : (
            <>
              <div className="deal-grid">
                {deals.slice(0, count).map((deal) => <DealCard key={deal.id} deal={deal} />)}
              </div>
              {count < deals.length && (
                <div className="home-loadmore">
                  <button type="button" onClick={() => setCount(count + PAGE_SIZE)}>Show More Deals</button>
                </div>
              )}
            </>
          )}
        </main>

        <aside className="home-sidebar">
          <div className="home-sidebar-box">
            <h3>Shop by Category</h3>
            {categoryLinks}
          </div>
        </aside>
      </div>
    </div>
  );
}

export default DealListPage;
